import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  DISPUTES,
  NOTIFICATION,
} from '../actionTypes';

const fetchDisputes = async (payload) => {
  let parms = '';
  const queryParam = payload.searchParam;
  if (queryParam && queryParam === 'ALL_DISPUTES') {
    parms = '';
  } else if (queryParam) {
    parms = `status.EQ=${queryParam}`;
  }
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (parms && !payload.filterParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_DISPUTES}${query}&${parms}${sorting}`);
  }
  if (payload.filterParams && !parms && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_DISPUTES}${query}&${payload.filterParams}`);
  }
  if (payload.filterParams && parms && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_DISPUTES}${query}&${parms}&${payload.filterParams}${sorting}`);
  }
  if (payload.filterParams && !parms && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_DISPUTES}${query}&${payload.filterParams}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_DISPUTES}${query}${sorting}`);
};

export function* getDisputes(action) {
  try {
    const { data: { entity } } = yield call(fetchDisputes, action.payload);
    yield put({ type: DISPUTES.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: DISPUTES.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}
